import React from 'react';
import PropTypes from 'prop-types';
import NextHead from 'next/head';

import { serializeJsonLd } from './serializeJsonLd';

// schema.org/BreadcrumbList JSON-LD. Takes the same items as the visible
// breadcrumb so the two cannot drift apart. The current page has no url,
// Google takes the page URL for the last item.
const ScriptMarkupBreadcrumb = ({ items, host }) => {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  const data = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      ...(item.url ? { item: `${host}${item.url}` } : {}),
    })),
  };

  return (
    <NextHead>
      <script
        key="ScriptMarkupBreadcrumb"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(data) }}
      />
    </NextHead>
  );
};

ScriptMarkupBreadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      // Host-relative path, omitted for the current page.
      url: PropTypes.string,
    }),
  ),
  host: PropTypes.string.isRequired,
};

export default ScriptMarkupBreadcrumb;
